import type { MailboxInfo } from 'owa-client-types';
import { AccountSourceType } from 'owa-account-source-list-types';
import { getCoprincipalAccountForMailboxInfo } from 'owa-account-source-list-store';
import providerToSource from 'owa-account-source-list-types/lib/utils/providerToSource';

export function getTypeHintFromMailboxInfo(mailboxInfo: MailboxInfo): AccountSourceType {
    if (!!mailboxInfo.mailboxProvider) {
        // If the mailbox provider is present we can use it to determine the account source type
        return providerToSource(mailboxInfo.mailboxProvider);
    }

    const accountSource = getCoprincipalAccountForMailboxInfo(mailboxInfo);
    return accountSource?.sourceType ?? AccountSourceType.Other;
}
